var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoingeckoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.484,
    height: 35.031,
    viewBox: "0 0 35.484 35.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coin_Gecko_AI",
    "data-name": "Coin Gecko AI",
    transform: "translate(-0.603 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M34.587,16.934A16.849,16.849,0,0,1,31.725,26.4a17.185,17.185,0,0,1-7.707,6.3,17.4,17.4,0,0,1-18.8-3.606,16.886,16.886,0,0,1,2.5-26.181A17.41,17.41,0,0,1,29.486,4.929,16.9,16.9,0,0,1,34.587,16.934Z",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#aaafd5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M18.665,2.434a9.4,9.4,0,0,1,3.242,0A9.956,9.956,0,0,1,25,3.458a17.974,17.974,0,0,1,2.62,1.894c.827.664,1.651,1.343,2.434,2.087a12.22,12.22,0,0,1,2.076,2.478,14.024,14.024,0,0,1,1.454,2.891,13,13,0,0,1,.6,6.341h-.1A28.9,28.9,0,0,0,32.495,13.2a23.062,23.062,0,0,0-1.248-2.771,27.18,27.18,0,0,0-1.641-2.6,9.491,9.491,0,0,0-2.2-2.191,12.88,12.88,0,0,0-2.794-1.363c-.953-.37-1.9-.754-2.891-1.036s-2-.493-3.058-.7Z",
    fill: "#aaafd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M26.91,12.049c-1.224-.349-2.492-.845-3.777-1.346A2.555,2.555,0,0,0,22.2,9.5c-.839-.719-2.416-.7-3.778-.382A9.553,9.553,0,0,0,14,8.992C2.341,12.163,8.953,19.9,4.672,27.673c.609,1.276,7.176,8.717,16.677,6.72,0,0-3.25-7.706,4.083-11.4C31.38,19.977,35.678,14.406,26.91,12.049Z",
    fill: "#aaafd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M28.348,17.111a.691.691,0,0,1-.117.388.7.7,0,0,1-.316.259.714.714,0,0,1-.771-.147.693.693,0,0,1,.1-1.074.713.713,0,0,1,.893.082A.694.694,0,0,1,28.348,17.111Z",
    fill: "#aaafd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M18.418,9.117A17.6,17.6,0,0,1,23.133,10.7C22.472,8.807,20.248,8.555,18.418,9.117Z",
    fill: "#0e1023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M19.226,13.9a3.189,3.189,0,0,1-.549,1.789,3.252,3.252,0,0,1-1.463,1.186,3.293,3.293,0,0,1-3.555-.7,3.2,3.2,0,0,1,.494-4.953,3.291,3.291,0,0,1,4.118.4,3.215,3.215,0,0,1,.707,1.044A3.182,3.182,0,0,1,19.226,13.9Z",
    fill: "#aaafd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M18.258,13.929a2.243,2.243,0,0,1-.387,1.258,2.288,2.288,0,0,1-1.03.834,2.317,2.317,0,0,1-2.5-.491,2.248,2.248,0,0,1,.348-3.483,2.317,2.317,0,0,1,2.9.282A2.249,2.249,0,0,1,18.258,13.929Z",
    fill: "#0e1023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M30.992,18.53a16.452,16.452,0,0,1-9.911,3.232c-2,0-2.4-2.087-3.719-1.067a9.47,9.47,0,0,1-4.985,1.624,6.185,6.185,0,0,1-5.852-5.2c-.341,4.012-.515,6.967-2.042,10.354,3.039,4.8,10.286,8.508,16.865,6.912-.707-4.871,3.606-9.642,6.037-12.083a31.753,31.753,0,0,0,3.606-3.77Z",
    fill: "#aaafd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M30.889,18.65A11.843,11.843,0,0,1,28.1,20.417a17.887,17.887,0,0,1-3.132,1.125,9.959,9.959,0,0,1-3.342.381A4.6,4.6,0,0,1,18.566,20.6l.036-.04a5.885,5.885,0,0,0,3.055.831,14.526,14.526,0,0,0,3.211-.261,17.66,17.66,0,0,0,3.12-.952,11.661,11.661,0,0,0,2.865-1.565Z",
    fill: "#0e1023"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoingeckoLogo);
export default __webpack_public_path__ + "static/media/coingecko-logo.a3f4a739aadada938674b03bcdb23fb2.svg";
export { ForwardRef as ReactComponent };